import { injectable } from 'inversify';
import { SelectedVariantOptions, VariantSettings } from '../../../types/Types';
import SortingService from '../../SortingService/SortingService';
import ProductVariant from './ProductVariant';
import ProductVariantOption from './ProductVariantOption';
import _ from 'lodash';
import { LocalProductOption, LocalProductVariant } from '../LocalProduct';

@injectable()
export default class ProductVariantHelperService {
    getVariantSettings(variants: LocalProductVariant[]): VariantSettings {
        return variants
            .map(variant => variant.options)
            .flat()
            .reduce((variantSettings: VariantSettings, { key, value }: LocalProductOption) => {
                const variantOptions = variantSettings[key];
                if (!variantOptions) {
                    variantSettings[key] = [value];
                    return variantSettings;
                }
                variantSettings[key] = _.uniq([...variantOptions, value]); //.sort(SortingService.sortAsc);
                return variantSettings;
            }, {});
    }

    getSelectedVariant(
        variants: LocalProductVariant[],
        selectedOptions: SelectedVariantOptions,
    ): LocalProductVariant | undefined {
        return variants.find(variant => variant.options.every(option => selectedOptions[option.key] === option.value));
    }

    getVariantsBySelectedOption(
        variants: LocalProductVariant[],
        selectedOptions: SelectedVariantOptions,
    ): LocalProductVariant[] {
        return variants.filter(variant =>
            Object.keys(selectedOptions).every(selectedOptionName =>
                this.hasVariantOptions(variant.options, selectedOptionName, selectedOptions[selectedOptionName]),
            ),
        );
    }

    hasVariant(variants: LocalProductVariant[], variantName: string, variantOption: string): boolean {
        return !!variants.find(variant => this.hasVariantOptions(variant.options, variantName, variantOption));
    }

    private hasVariantOptions(options: LocalProductOption[], variantName: string, variantOption: string): boolean {
        return !!options.find(option => this.hasVariantOption(option, variantName, variantOption));
    }

    private hasVariantOption(option: LocalProductOption, variantName: string, variantOption: string): boolean {
        return option.key === variantName && option.value === variantOption;
    }
}
